import React from 'react'
import Icon from '@ant-design/icons'

export const Lifestyle = (props) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8 9V15C10.1217 15 12.1566 14.1571 13.6569 12.6569C15.1571 11.1566 16 9.12173 16 7V1C13.8783 1 11.8434 1.84285 10.3431 3.34315C8.84285 4.84344 8 6.87827 8 9Z"
      fill={props.color}
    />
    <path
      d="M0 6V9C0 10.5913 0.632141 12.1174 1.75736 13.2426C2.88258 14.3679 4.4087 15 6 15V12C6 10.4087 5.36786 8.88258 4.24264 7.75736C3.11742 6.63214 1.5913 6 0 6H0Z"
      fill={props.color}
    />
  </svg>
)

export const About = (props) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8 0C3.6 0 0 3.6 0 8C0 12.4 3.6 16 8 16C12.4 16 16 12.4 16 8C16 3.6 12.4 0 8 0ZM9 12H7V7H9V12ZM8 6C7.4 6 7 5.6 7 5C7 4.4 7.4 4 8 4C8.6 4 9 4.4 9 5C9 5.6 8.6 6 8 6Z"
      fill={props.color}
    />
  </svg>
)

export const Heartbeat = (props) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0)">
      <path
        d="M4.28933 7.33326L6.09533 4.32326C6.15807 4.21568 6.25012 4.12815 6.36072 4.0709C6.47133 4.01365 6.59593 3.98904 6.72 3.99993C6.84379 4.00977 6.96236 4.054 7.06237 4.12762C7.16237 4.20123 7.23982 4.30132 7.286 4.41659L9.45333 9.83593L10.762 7.65459C10.8215 7.55636 10.9053 7.47516 11.0054 7.41886C11.1055 7.36256 11.2185 7.33307 11.3333 7.33326H15.5593C15.8315 6.7005 15.981 6.02181 16 5.33326C16.0038 4.71936 15.8857 4.11082 15.6525 3.54291C15.4193 2.97501 15.0757 2.45904 14.6416 2.02494C14.2075 1.59084 13.6916 1.24724 13.1237 1.01407C12.5558 0.780895 11.9472 0.662787 11.3333 0.666593C10.081 0.675197 8.88288 1.17842 8 2.06659C7.11711 1.17842 5.91897 0.675197 4.66666 0.666593C4.05277 0.662787 3.44422 0.780895 2.87631 1.01407C2.30841 1.24724 1.79245 1.59084 1.35835 2.02494C0.924247 2.45904 0.580648 2.97501 0.347474 3.54291C0.1143 4.11082 -0.00380867 4.71936 -2.40048e-06 5.33326C0.0189578 6.02181 0.168495 6.7005 0.440664 7.33326H4.28933Z"
        fill={props.color}
      />
      <path
        d="M11.7106 8.66653L9.90463 11.6765C9.84539 11.7751 9.76164 11.8567 9.66152 11.9134C9.56141 11.9701 9.44833 11.9998 9.3333 11.9999H9.27997C9.15618 11.99 9.0376 11.9458 8.9376 11.8722C8.8376 11.7986 8.76014 11.6985 8.71397 11.5832L6.54663 6.16187L5.23797 8.3432C5.17872 8.44181 5.09497 8.52341 4.99486 8.58006C4.89474 8.63672 4.78167 8.66651 4.66663 8.66653H1.09863C3.14197 12.1925 7.34797 15.6665 7.59997 15.8665C7.65251 15.9171 7.71569 15.9554 7.78489 15.9784C7.85409 16.0015 7.92757 16.0088 7.99997 15.9999C8.14162 15.986 8.27834 15.9405 8.39997 15.8665C8.65197 15.6665 12.858 12.1925 14.9013 8.66653H11.7106Z"
        fill={props.color}
      />
    </g>
    <defs>
      <clipPath id="clip0">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
)

export const Trash = (props) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="currentColor"
    {...props}
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0)">
      <path d="M2.00049 6L2.00049 14C2.00049 15.1 2.90049 16 4.00049 16L12.0005 16C13.1005 16 14.0005 15.1 14.0005 14L14.0005 6L2.00049 6Z" />
      <path d="M12.0005 3L12.0005 1C12.0005 0.400002 11.6005 2.02821e-06 11.0005 1.9233e-06L5.00049 8.74228e-07C4.40049 7.6932e-07 4.00049 0.400001 4.00049 1L4.00049 3L0.000487757 3L0.000487407 5L16.0005 5L16.0005 3L12.0005 3ZM10.0005 3L6.00049 3L6.00049 2L10.0005 2L10.0005 3Z" />
    </g>
    <defs>
      <clipPath id="clip0">
        <rect width="16" height="16" transform="translate(0.000488281)" />
      </clipPath>
    </defs>
  </svg>
)

const downSvg = (props) => (
  <svg
    viewBox="0 0 15 8"
    width="1em"
    height="1em"
    fill="currentColor"
    {...props}
  >
    <path d="M1.95881 0L7.5 4.98889L13.0412 0L15 1.76357L8.4794 7.63425C7.93775 8.12192 7.06225 8.12192 6.52059 7.63425L-9.53674e-07 1.76357L1.95881 0Z" />
  </svg>
)

export const DownIcon = (props) => <Icon component={downSvg} {...props} />

const shareFill = (props) => (
  <svg
    width="15"
    height="15"
    viewBox="0 0 15 15"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M11.8748 5C13.2498 5 14.3748 3.875 14.3748 2.5C14.3748 1.125 13.2498 0 11.8748 0C10.4998 0 9.37482 1.125 9.37482 2.5C9.37482 2.75 9.43732 2.9375 9.49982 3.125L4.93732 5.75C4.43732 5.3125 3.81232 5 3.12482 5C1.74982 5 0.624817 6.125 0.624817 7.5C0.624817 8.875 1.74982 10 3.12482 10C3.81232 10 4.43732 9.6875 4.93732 9.25L9.49982 11.875C9.43732 12.0625 9.37482 12.3125 9.37482 12.5C9.37482 13.875 10.4998 15 11.8748 15C13.2498 15 14.3748 13.875 14.3748 12.5C14.3748 11.125 13.2498 10 11.8748 10C11.1873 10 10.5623 10.3125 10.0623 10.75L5.49982 8.125C5.56232 7.9375 5.62482 7.75 5.62482 7.5C5.62482 7.25 5.56232 7.0625 5.49982 6.875L10.0623 4.25C10.5623 4.6875 11.1873 5 11.8748 5Z" />
  </svg>
)

export const ShareIcon = (props) => <Icon component={shareFill} {...props} />

const pen = (props) => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M10.121 0.292786C9.93347 0.105315 9.67916 0 9.414 0C9.14884 0 8.89453 0.105315 8.707 0.292786L1 7.99979L0 11.9998L4 10.9998L11.707 3.29279C11.8945 3.10526 11.9998 2.85095 11.9998 2.58579C11.9998 2.32062 11.8945 2.06631 11.707 1.87879L10.121 0.292786Z" />
  </svg>
)

export const PenIcon = (props) => <Icon component={pen} {...props} />

const generateReport = (props) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M11 4H5V5H11V4Z" />
    <path d="M11 7H5V8H11V7Z" />
    <path d="M7 10H5V11H7V10Z" />
    <path d="M16 12H14V10H12V12H10V14H12V16H14V14H16V12Z" />
    <path d="M7.99999 14.0002H2.99999V2.00024H13V8.00024H15V1.00024C15.008 0.866825 14.9876 0.733227 14.9402 0.608267C14.8928 0.483307 14.8194 0.369827 14.7249 0.275319C14.6304 0.180811 14.5169 0.107426 14.392 0.060008C14.267 0.01259 14.1334 -0.00778171 14 0.000237932H1.99999C1.86658 -0.00778171 1.73298 0.01259 1.60802 0.060008C1.48306 0.107426 1.36958 0.180811 1.27508 0.275319C1.18057 0.369827 1.10718 0.483307 1.05976 0.608267C1.01235 0.733227 0.991974 0.866825 0.999994 1.00024V15.0002C0.991974 15.1337 1.01235 15.2672 1.05976 15.3922C1.10718 15.5172 1.18057 15.6306 1.27508 15.7252C1.36958 15.8197 1.48306 15.8931 1.60802 15.9405C1.73298 15.9879 1.86658 16.0083 1.99999 16.0002H7.99999V14.0002Z" />
  </svg>
)

export const GenerateReportIcon = (props) => (
  <Icon component={generateReport} {...props} />
)

const upload = (props) => (
  <svg
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M7.0001 4.25L7.0001 11.6875H9.0001L9.0001 4.25H11.4001L8.0001 0L4.6001 4.25H7.0001Z" />
    <path d="M15 17H1C0.4 17 0 16.575 0 15.9375L0 6.375C0 5.7375 0.4 5.3125 1 5.3125L4 5.3125L4 7.4375H2L2 14.875L14 14.875L14 7.4375H12V5.3125H15C15.6 5.3125 16 5.7375 16 6.375L16 15.9375C16 16.575 15.6 17 15 17Z" />
  </svg>
)

export const UploadIcon = (props) => <Icon component={upload} {...props} />

const simpleUpload = (props) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M7.49984 13.3333H12.4998V8.33333H15.8332L9.99984 2.5L4.1665 8.33333H7.49984V13.3333ZM4.1665 15H15.8332V16.6667H4.1665V15Z" />
  </svg>
)

export const SimpleUploadIcon = (props) => (
  <Icon component={simpleUpload} {...props} />
)

const bell = (props) => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.5 10.5H4.5C4.5 11.325 5.175 12 6 12C6.825 12 7.5 11.325 7.5 10.5Z"
      // fill="#FBFDFD"
    />
    <path
      d="M11.25 8.25H10.875C10.35 7.725 9.75 6.975 9.75 6V3.75C9.75 1.65 8.1 0 6 0C3.9 0 2.25 1.65 2.25 3.75V6C2.25 6.975 1.65 7.725 1.125 8.25H0.75C0.3 8.25 0 8.55 0 9C0 9.45 0.3 9.75 0.75 9.75H11.25C11.7 9.75 12 9.45 12 9C12 8.55 11.7 8.25 11.25 8.25Z"
      // fill="#FBFDFD"
    />
  </svg>
)

export const BellIcon = (props) => <Icon component={bell} {...props} />

const tray = (props) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M6 0H1C0.4 0 0 0.4 0 1V6C0 6.6 0.4 7 1 7H6C6.6 7 7 6.6 7 6V1C7 0.4 6.6 0 6 0Z" />
    <path d="M15 0H10C9.4 0 9 0.4 9 1V6C9 6.6 9.4 7 10 7H15C15.6 7 16 6.6 16 6V1C16 0.4 15.6 0 15 0Z" />
    <path d="M6 9H1C0.4 9 0 9.4 0 10V15C0 15.6 0.4 16 1 16H6C6.6 16 7 15.6 7 15V10C7 9.4 6.6 9 6 9Z" />
    <path d="M15 9H10C9.4 9 9 9.4 9 10V15C9 15.6 9.4 16 10 16H15C15.6 16 16 15.6 16 15V10C16 9.4 15.6 9 15 9Z" />
  </svg>
)

export const TrayIcon = (props) => <Icon component={tray} {...props} />

const del = (props) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15 6.75L14.3497 15.8565C14.3228 16.2349 14.1535 16.5891 13.8758 16.8477C13.5982 17.1063 13.2329 17.25 12.8535 17.25H5.1465C4.7671 17.25 4.4018 17.1063 4.12416 16.8477C3.84653 16.5891 3.67719 16.2349 3.65025 15.8565L3 6.75"
      stroke="#EA5400"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinejoin="round"
    />
    <path
      d="M0.75 4H17.25"
      stroke="#EA5400"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinejoin="round"
    />
    <path
      d="M6 3.75V1.5C6 1.30109 6.07902 1.11032 6.21967 0.96967C6.36032 0.829018 6.55109 0.75 6.75 0.75H11.25C11.4489 0.75 11.6397 0.829018 11.7803 0.96967C11.921 1.11032 12 1.30109 12 1.5V3.75"
      stroke="#EA5400"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinejoin="round"
    />
  </svg>
)

export const DelIcon = (props) => <Icon component={del} {...props} />

const download = (props) => (
  <svg
    width="17"
    height="17"
    viewBox="0 0 17 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1 11.1115V15.556H15.2698V11.1115"
      stroke="#75879D"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinejoin="round"
    />
    <path
      d="M8.13477 0V11.1114"
      stroke="#75879D"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinejoin="round"
    />
    <path
      d="M3.854 6.66675L8.13498 11.1113L12.416 6.66675"
      stroke="#75879D"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinejoin="round"
    />
  </svg>
)

export const DownloadIcon = (props) => <Icon component={download} {...props} />

const exportSvg = (props) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M8.9999 7L8.9999 -2.09815e-07L6.9999 -3.8466e-07L6.9999 7L4.5999 7L7.9999 11L11.3999 7L8.9999 7Z"
      // fill="#264382"
    />
    <path
      d="M15 16H1C0.4 16 0 15.6 0 15V6C0 5.4 0.4 5 1 5H4V7H2V14H14V7H12V5H15C15.6 5 16 5.4 16 6V15C16 15.6 15.6 16 15 16Z"
      // fill="#264382"
    />
  </svg>
)

export const ExportIcon = (props) => <Icon component={exportSvg} {...props} />

const bars = (props) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M2 4C3.10457 4 4 3.10457 4 2C4 0.89543 3.10457 0 2 0C0.89543 0 0 0.89543 0 2C0 3.10457 0.89543 4 2 4Z" />
    <path d="M2 10C3.10457 10 4 9.10457 4 8C4 6.89543 3.10457 6 2 6C0.89543 6 0 6.89543 0 8C0 9.10457 0.89543 10 2 10Z" />
    <path d="M2 16C3.10457 16 4 15.1046 4 14C4 12.8954 3.10457 12 2 12C0.89543 12 0 12.8954 0 14C0 15.1046 0.89543 16 2 16Z" />
    <path d="M16 1H6V3H16V1Z" />
    <path d="M16 7H6V9H16V7Z" />
    <path d="M16 13H6V15H16V13Z" />
  </svg>
)

export const BarsIcon = (props) => <Icon component={bars} {...props} />

const CollapsePlus = (props) => (
  <svg
    width="13"
    height="13"
    viewBox="0 0 13 13"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    {/* <path
      d="M21.6667 10H18.3333V18.3333H10V21.6667H18.3333V30H21.6667V21.6667H30V18.3333H21.6667V10Z"
      // fill="#4C6072"
    /> */}
    <path d="M7.54167 0.25H5.45833V5.45833H0.25V7.54167H5.45833V12.75H7.54167V7.54167H12.75V5.45833H7.54167V0.25Z" />
  </svg>
)

export const CollapsePlusIcon = (props) => (
  <Icon component={CollapsePlus} {...props} />
)

const CircleCheck = (props) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.0382 7.08934L8.37935 11.6902L7.10997 10.239C6.8276 9.91617 6.33642 9.88301 6.01312 10.1659C5.68982 10.4488 5.65718 10.9394 5.94007 11.2627L7.75346 13.3352C7.89439 13.4963 8.09594 13.5922 8.30992 13.6C8.31976 13.6005 8.32909 13.6005 8.33842 13.6005C8.54255 13.6005 8.73892 13.5202 8.88451 13.3767L14.1304 8.19552C14.4356 7.89346 14.4387 7.40125 14.1371 7.09608C13.8356 6.79091 13.3434 6.7878 13.0382 7.08934ZM9.97347 18.393C5.33065 18.393 1.55412 14.6165 1.55412 9.97368C1.55412 5.33138 5.33065 1.55434 9.97347 1.55434C14.6158 1.55434 18.3928 5.33138 18.3928 9.97368C18.3928 14.6165 14.6158 18.393 9.97347 18.393ZM9.97368 0C4.47391 0 0 4.47443 0 9.97368C0 15.4729 4.47391 19.9474 9.97368 19.9474C15.4729 19.9474 19.9474 15.4729 19.9474 9.97368C19.9474 4.47443 15.4729 0 9.97368 0Z"
    />
  </svg>
)

export const CircleCheckIcon = (props) => (
  <Icon component={CircleCheck} {...props} />
)

const Archived = (props) => (
  <svg
    width="21"
    height="21"
    viewBox="0 0 21 21"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M18.375 1.05C18.2437 0.39375 17.7188 0 17.0625 0H3.9375C3.28125 0 2.75625 0.39375 2.625 1.05C2.625 1.05 0 13.7812 0 14.4375V19.6875C0 20.475 0.525 21 1.3125 21H19.6875C20.475 21 21 20.475 21 19.6875V14.4375C21 13.7812 18.375 1.05 18.375 1.05ZM4.9875 2.625H16.0125L18.1125 13.125H14.4375C13.65 13.125 13.125 13.65 13.125 14.4375V15.75H7.875V14.4375C7.875 13.65 7.35 13.125 6.5625 13.125H2.8875L4.9875 2.625Z" />
  </svg>
)

export const ArchivedIcon = (props) => <Icon component={Archived} {...props} />

const setting = (props) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M12.9 4.5L14.4 3L13 1.6L11.5 3.1C10.8 2.6 9.9 2.2 9 2.1V0H7V2.1C6.1 2.3 5.2 2.6 4.5 3.1L3.1 1.6L1.6 3.1L3.1 4.6C2.6 5.2 2.2 6.1 2.1 7H0V9H2.1C2.3 9.9 2.6 10.8 3.1 11.5L1.6 13L3 14.4L4.5 12.9C5.2 13.4 6.1 13.8 7 13.9V16H9V13.9C9.9 13.7 10.8 13.4 11.5 12.9L13 14.4L14.4 13L12.9 11.5C13.4 10.8 13.8 9.9 13.9 9H16V7H13.9C13.8 6.1 13.4 5.2 12.9 4.5ZM8 11C6.3 11 5 9.7 5 8C5 6.3 6.3 5 8 5C9.7 5 11 6.3 11 8C11 9.7 9.7 11 8 11Z"
      fill="#264382"
    />
  </svg>
)

export const SettingIcon = (props) => <Icon component={setting} {...props} />

const vectorPlus = (props) => (
  <svg
    width="34"
    height="34"
    viewBox="0 0 34 34"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M31.875 14.875H19.125V2.125C19.125 0.85 18.275 0 17 0C15.725 0 14.875 0.85 14.875 2.125V14.875H2.125C0.85 14.875 0 15.725 0 17C0 18.275 0.85 19.125 2.125 19.125H14.875V31.875C14.875 33.15 15.725 34 17 34C18.275 34 19.125 33.15 19.125 31.875V19.125H31.875C33.15 19.125 34 18.275 34 17C34 15.725 33.15 14.875 31.875 14.875Z" />
  </svg>
)

export const VectorPlusIcon = (props) => (
  <Icon component={vectorPlus} {...props} />
)

const editPan = (props) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="rgba(38, 67, 130, 1)"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M16 14L0 14L0 16H16V14Z" />
    <path d="M11.7 3.3C12.1 2.9 12.1 2.3 11.7 1.9L10.1 0.3C9.7 -0.1 9.1 -0.1 8.7 0.3L0 9L0 12H3L11.7 3.3Z" />
  </svg>
)

export const EditPanIcon = (props) => <Icon component={editPan} {...props} />

const file = (props) => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M10 0.5H7.921L8.721 1.5H10C10.1326 1.5 10.2598 1.55268 10.3536 1.64645C10.4473 1.74021 10.5 1.86739 10.5 2V7.5H7.5V9H4.5V7.5H1.5V2C1.5 1.86739 1.55268 1.74021 1.64645 1.64645C1.74021 1.55268 1.86739 1.5 2 1.5H3.279L4.079 0.5H2C1.60218 0.5 1.22064 0.658035 0.93934 0.93934C0.658035 1.22064 0.5 1.60218 0.5 2V10C0.5 10.3978 0.658035 10.7794 0.93934 11.0607C1.22064 11.342 1.60218 11.5 2 11.5H10C10.3978 11.5 10.7794 11.342 11.0607 11.0607C11.342 10.7794 11.5 10.3978 11.5 10V2C11.5 1.60218 11.342 1.22064 11.0607 0.93934C10.7794 0.658035 10.3978 0.5 10 0.5Z" />
  </svg>
)

export const FileIcon = (props) => <Icon component={file} {...props} />

const link = (props) => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M3.37515 12C2.47515 12 1.65015 11.625 0.975146 11.025C-0.374854 9.67498 -0.374854 7.57498 0.975146 6.22498L1.50015 5.69998L2.55015 6.74998L2.02515 7.27498C1.27515 8.02498 1.27515 9.22498 2.02515 9.97498C2.77515 10.725 3.97515 10.725 4.72515 9.97498L6.97515 7.72498C7.72515 6.97498 7.72515 5.77498 6.97515 5.02498L6.45015 4.49998L7.50015 3.44998L8.02515 3.97498C9.37515 5.32498 9.37515 7.42498 8.02515 8.77498L5.77515 11.025C5.17515 11.625 4.27515 12 3.37515 12Z" />
    <path d="M4.50015 8.55L3.97515 8.025C2.62515 6.675 2.62515 4.575 3.97515 3.225L6.22515 0.975C6.90015 0.3 7.72515 0 8.62515 0C9.52515 0 10.3501 0.375 11.0251 0.975C12.3751 2.325 12.3751 4.425 11.0251 5.775L10.5001 6.3L9.45015 5.25L9.97515 4.725C10.7251 3.975 10.7251 2.775 9.97515 2.025C9.22515 1.275 8.02515 1.275 7.27515 2.025L5.02515 4.275C4.27515 5.025 4.27515 6.225 5.02515 6.975L5.55015 7.5L4.50015 8.55Z" />
  </svg>
)

export const LinkIcon = (props) => <Icon component={link} {...props} />

const back = (props) => (
  <svg
    width="26"
    height="26"
    viewBox="0 0 26 26"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M16.5003 0.75H2.50029V4.25H16.5003C19.4753 4.25 21.7503 6.525 21.7503 9.5C21.7503 12.475 19.4753 14.75 16.5003 14.75H6.70029L11.9503 9.5L9.50029 7.05L0.050293 16.5L9.50029 25.95L11.9503 23.5L6.70029 18.25H16.5003C21.4003 18.25 25.2503 14.4 25.2503 9.5C25.2503 4.6 21.4003 0.75 16.5003 0.75Z" />
  </svg>
)

export const BackIcon = (props) => <Icon component={back} {...props} />
const user = (props) => (
  <svg
    width="15"
    height="15"
    viewBox="0 0 15 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.5 6.875C9.22589 6.875 10.625 5.47589 10.625 3.75C10.625 2.02411 9.22589 0.625 7.5 0.625C5.77411 0.625 4.375 2.02411 4.375 3.75C4.375 5.47589 5.77411 6.875 7.5 6.875Z"
      stroke="#264382"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.5 9.375C3.7025 9.375 1.875 11.7437 1.875 13.125V14.375H13.125V13.125C13.125 11.75 11.2975 9.375 7.5 9.375Z"
      stroke="#264382"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const UserIcon = (props) => <Icon component={user} {...props} />

const view = (props) => (
  <svg
    width="19"
    height="13"
    viewBox="0 0 19 13"
    fill="none"
    stroke="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.7474 5.90884C17.9078 6.14245 18.0363 6.34383 18.1321 6.5C18.0363 6.65617 17.9078 6.85755 17.7474 7.09116C17.3479 7.67312 16.7557 8.44804 15.9858 9.2206C14.4355 10.7763 12.2407 12.25 9.5 12.25C6.75932 12.25 4.56452 10.7763 3.01421 9.2206C2.24435 8.44804 1.65206 7.67312 1.25256 7.09116C1.09219 6.85755 0.963665 6.65617 0.867907 6.5C0.963665 6.34383 1.09219 6.14245 1.25256 5.90884C1.65206 5.32688 2.24435 4.55196 3.01421 3.7794C4.56452 2.22365 6.75932 0.75 9.5 0.75C12.2407 0.75 14.4355 2.22365 15.9858 3.7794C16.7557 4.55196 17.3479 5.32688 17.7474 5.90884ZM18.3381 6.85268C18.3381 6.85276 18.3381 6.85274 18.3381 6.85262L18.3381 6.85268Z"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.25 6.5C12.25 8.01878 11.0188 9.25 9.5 9.25C7.98122 9.25 6.75 8.01878 6.75 6.5C6.75 4.98122 7.98122 3.75 9.5 3.75C11.0188 3.75 12.25 4.98122 12.25 6.5Z"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const ViewIcon = (props) => <Icon component={view} {...props} />

export const FileShareIcon = (props) => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle opacity={0.1} cx={20} cy={20} r={20} fill="#75879D" />
    <path
      d="M14 22.765v3.906h12.54v-3.906M20.27 22.765v-9.764M24.032 16.906L20.27 13l-3.762 3.906"
      stroke="#75879D"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinejoin="round"
    />
  </svg>
)

const simpleCheck = (props) => (
  <svg
    width="9"
    height="7"
    viewBox="0 0 9 7"
    {...props}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1 4L3 6L7.33333 1"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const SimpleCheckIcon = (props) => (
  <Icon component={simpleCheck} {...props} />
)

const canladar = (props) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M14 3H13V1C13 0.734784 12.8946 0.48043 12.7071 0.292893C12.5196 0.105357 12.2652 0 12 0C11.7348 0 11.4804 0.105357 11.2929 0.292893C11.1054 0.48043 11 0.734784 11 1V3H5V1C5 0.734784 4.89464 0.48043 4.70711 0.292893C4.51957 0.105357 4.26522 0 4 0C3.73478 0 3.48043 0.105357 3.29289 0.292893C3.10536 0.48043 3 0.734784 3 1V3H2C1.46957 3 0.960859 3.21071 0.585786 3.58579C0.210714 3.96086 0 4.46957 0 5L0 14C0 14.5304 0.210714 15.0391 0.585786 15.4142C0.960859 15.7893 1.46957 16 2 16H14C14.5304 16 15.0391 15.7893 15.4142 15.4142C15.7893 15.0391 16 14.5304 16 14V5C16 4.46957 15.7893 3.96086 15.4142 3.58579C15.0391 3.21071 14.5304 3 14 3ZM2 14V7H14V14H2Z" />
  </svg>
)

export const CalendarIcon = (props) => <Icon component={canladar} {...props} />

const notes = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.375 8.625H3.96079L3.66789 8.91789L1 11.5858V1.75C1 1.33541 1.33541 1 1.75 1H12.25C12.6646 1 13 1.33541 13 1.75V7.875C13 8.28959 12.6646 8.625 12.25 8.625H4.375Z"
      stroke="currentColor"
      strokeWidth="2"
    />
  </svg>
)

export const NotesIcon = (props) => <Icon component={notes} {...props} />

const blankLink = (props) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M16 0H9.99997L12.293 2.293L6.02197 8.564L7.43597 9.978L13.707 3.707L16 6V0Z" />
    <path d="M13 16H1C0.448 16 0 15.552 0 15V3C0 2.448 0.448 2 1 2H7V4H2V14H12V9H14V15C14 15.552 13.552 16 13 16Z" />
  </svg>
)

export const BlankLinkIcon = (props) => (
  <Icon component={blankLink} {...props} />
)

const sendEmail = (props) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M14.6667 13.338C14.6654 13.5131 14.5954 13.6807 14.4717 13.8045C14.3479 13.9284 14.1804 13.9986 14.0053 14H1.99467C1.81921 13.9998 1.651 13.93 1.52699 13.8059C1.40299 13.6817 1.33333 13.5135 1.33333 13.338V12.6667H13.3333V4.86667L8 9.66667L1.33333 3.66667V2.66667C1.33333 2.48986 1.40357 2.32029 1.5286 2.19526C1.65362 2.07024 1.82319 2 2 2H14C14.1768 2 14.3464 2.07024 14.4714 2.19526C14.5964 2.32029 14.6667 2.48986 14.6667 2.66667V13.338ZM2.956 3.33333L8 7.87333L13.044 3.33333H2.956ZM0 10H5.33333V11.3333H0V10ZM0 6.66667H3.33333V8H0V6.66667Z" />
  </svg>
)

export const SendEmailIcon = (props) => (
  <Icon component={sendEmail} {...props} />
)

const chart = (props) => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <mask id="path-1-inside-1_41249_53625" fill="white">
      <path d="M0.979535 10.5712C0.109491 9.1045 -0.195187 7.3706 0.122714 5.69512C0.440615 4.01964 1.35923 2.51784 2.70605 1.47172C4.05288 0.42561 5.73527 -0.0928567 7.43731 0.0136812C9.13935 0.120219 10.744 0.844433 11.9498 2.05033C13.1557 3.25623 13.8798 4.86086 13.9863 6.5629C14.0928 8.26495 13.5743 9.94732 12.5281 11.2941C11.482 12.6409 9.98017 13.5595 8.30468 13.8773C6.62919 14.1952 4.89529 13.8904 3.42858 13.0204V13.0203L1.00995 13.7113C0.909886 13.7399 0.803992 13.7412 0.703246 13.7151C0.602501 13.689 0.51057 13.6364 0.436979 13.5628C0.363389 13.4893 0.310816 13.3973 0.284711 13.2966C0.258606 13.1958 0.259917 13.0899 0.288509 12.9899L0.979535 10.5712V10.5712Z" />
    </mask>
    <path
      d="M0.979535 10.5712L-0.310568 11.3365C0.0341199 11.9176 0.724742 12.1965 1.3763 12.0178C2.02786 11.8391 2.47953 11.2469 2.47953 10.5712H0.979535ZM3.42858 13.0204H1.92858C1.92858 13.5499 2.20782 14.0403 2.66328 14.3104L3.42858 13.0204ZM3.42858 13.0203H4.92858C4.92858 12.5496 4.70765 12.1062 4.33188 11.8228C3.95611 11.5393 3.46908 11.4487 3.01651 11.578L3.42858 13.0203ZM1.00995 13.7113L0.597878 12.269L0.597862 12.269L1.00995 13.7113ZM0.288509 12.9899L1.73079 13.402L1.7308 13.4019L0.288509 12.9899ZM0.979535 10.5712H2.47953C2.47953 9.82312 1.92839 9.18941 1.18758 9.08566C0.446763 8.98191 -0.257261 9.43984 -0.462756 10.1591L0.979535 10.5712ZM2.26964 9.80597C1.58603 8.65354 1.34664 7.29118 1.59642 5.97474L-1.35099 5.4155C-1.73702 7.45001 -1.36705 9.55547 -0.310568 11.3365L2.26964 9.80597ZM1.59642 5.97474C1.8462 4.65829 2.56797 3.4783 3.62618 2.65636L1.78592 0.287093C0.150485 1.55738 -0.964971 3.38099 -1.35099 5.4155L1.59642 5.97474ZM3.62618 2.65636C4.6844 1.83441 6.00628 1.42704 7.3436 1.51075L7.53102 -1.48339C5.46425 -1.61276 3.42135 -0.983189 1.78592 0.287093L3.62618 2.65636ZM7.3436 1.51075C8.68092 1.59446 9.94168 2.16348 10.8891 3.11098L13.0105 0.989686C11.5462 -0.474619 9.59778 -1.35402 7.53102 -1.48339L7.3436 1.51075ZM10.8891 3.11098C11.8366 4.05847 12.4056 5.31924 12.4893 6.65657L15.4834 6.46924C15.3541 4.40247 14.4748 2.45399 13.0105 0.989686L10.8891 3.11098ZM12.4893 6.65657C12.5729 7.99389 12.1655 9.31575 11.3435 10.3739L13.7128 12.2143C14.9831 10.5789 15.6127 8.53601 15.4834 6.46924L12.4893 6.65657ZM11.3435 10.3739C10.5216 11.4321 9.34156 12.1539 8.0251 12.4036L8.58425 15.351C10.6188 14.9651 12.4424 13.8497 13.7128 12.2143L11.3435 10.3739ZM8.0251 12.4036C6.70865 12.6533 5.3463 12.4139 4.19389 11.7303L2.66328 14.3104C4.44428 15.367 6.54973 15.737 8.58425 15.351L8.0251 12.4036ZM4.92858 13.0204V13.0203H1.92858V13.0204H4.92858ZM3.01651 11.578L0.597878 12.269L1.42203 15.1536L3.84066 14.4626L3.01651 11.578ZM0.597862 12.269C0.755012 12.2241 0.921303 12.2221 1.0795 12.2631L0.32699 15.1672C0.68668 15.2604 1.06476 15.2557 1.42205 15.1536L0.597862 12.269ZM1.0795 12.2631C1.23771 12.3041 1.38207 12.3866 1.49764 12.5022L-0.623681 14.6235C-0.360934 14.8863 -0.0327042 15.0739 0.32699 15.1672L1.0795 12.2631ZM1.49764 12.5022C1.61321 12.6177 1.69576 12.7621 1.73675 12.9203L-1.16733 13.6728C-1.07413 14.0325 -0.886428 14.3608 -0.623681 14.6235L1.49764 12.5022ZM1.73675 12.9203C1.77775 13.0785 1.77569 13.2448 1.73079 13.402L-1.15377 12.5778C-1.25586 12.9351 -1.26054 13.3131 -1.16733 13.6728L1.73675 12.9203ZM1.7308 13.4019L2.42183 10.9832L-0.462756 10.1591L-1.15378 12.5778L1.7308 13.4019ZM-0.520465 10.5712V10.5712H2.47953V10.5712H-0.520465Z"
      mask="url(#path-1-inside-1_41249_53625)"
    />
    <path d="M6.93516 7.74043C7.38124 7.74043 7.74287 7.3788 7.74287 6.93271C7.74287 6.48663 7.38124 6.125 6.93516 6.125C6.48907 6.125 6.12744 6.48663 6.12744 6.93271C6.12744 7.3788 6.48907 7.74043 6.93516 7.74043Z" />
    <path d="M3.43271 7.74043C3.8788 7.74043 4.24043 7.3788 4.24043 6.93271C4.24043 6.48663 3.8788 6.125 3.43271 6.125C2.98663 6.125 2.625 6.48663 2.625 6.93271C2.625 7.3788 2.98663 7.74043 3.43271 7.74043Z" />
    <path
      d="M10.4352 7.74043C10.8812 7.74043 11.2429 7.3788 11.2429 6.93271C11.2429 6.48663 10.8812 6.125 10.4352 6.125C9.98907 6.125 9.62744 6.48663 9.62744 6.93271C9.62744 7.3788 9.98907 7.74043 10.4352 7.74043Z"
      // fill="#E75F25"
    />
  </svg>
)

export const ChartIcon = (props) => <Icon component={chart} {...props} />

const filter = (props) => (
  <svg
    {...props}
    width="10"
    height="6"
    viewBox="0 0 10 6"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.0625 0.5H0.9375"
      stroke="currentColor"
      strokeWidth="0.625"
      strokeLinecap="square"
    />
    <path
      d="M7.8125 3H2.1875"
      stroke="currentColor"
      strokeWidth="0.625"
      strokeLinecap="square"
    />
    <path
      d="M6.5625 5.5H3.4375"
      stroke="currentColor"
      strokeWidth="0.625"
      strokeLinecap="square"
    />
  </svg>
)

export const FilterIcon = (props) => <Icon component={filter} {...props} />

const dragHandler = (props) => (
  <svg
    width="14"
    height="23"
    fill="none"
    viewBox="0 0 14 23"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M5.6 19.688A2.815 2.815 0 0 1 2.8 22.5c-1.54 0-2.8-1.266-2.8-2.813a2.815 2.815 0 0 1 2.8-2.812c1.54 0 2.8 1.266 2.8 2.813ZM2.8 8.438C1.26 8.438 0 9.703 0 11.25a2.815 2.815 0 0 0 2.8 2.813c1.54 0 2.8-1.266 2.8-2.813a2.815 2.815 0 0 0-2.8-2.813ZM2.8 0C1.26 0 0 1.266 0 2.813a2.815 2.815 0 0 0 2.8 2.812c1.54 0 2.8-1.266 2.8-2.813A2.815 2.815 0 0 0 2.8 0Zm8.4 5.625c1.54 0 2.8-1.266 2.8-2.813A2.815 2.815 0 0 0 11.2 0C9.66 0 8.4 1.266 8.4 2.813a2.815 2.815 0 0 0 2.8 2.812Zm0 2.813c-1.54 0-2.8 1.265-2.8 2.812a2.815 2.815 0 0 0 2.8 2.813c1.54 0 2.8-1.266 2.8-2.813a2.815 2.815 0 0 0-2.8-2.813Zm0 8.437c-1.54 0-2.8 1.266-2.8 2.813a2.815 2.815 0 0 0 2.8 2.812c1.54 0 2.8-1.266 2.8-2.813a2.815 2.815 0 0 0-2.8-2.812Z"
      fill="#CBD2D9"
    />
  </svg>
)

export const DragHandlerIcon = (props) => (
  <Icon component={dragHandler} {...props} />
)
